import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { arrayMove } from '@dnd-kit/sortable';
import { areObjectsEqual } from '../../../../common/utils/utils';
import { selectColumnsOrder } from '../../slice';

const FILTER_COLID_FOR_SORT = ['archive', 'openticket'];

interface Column {
  colId: string;
  headerName: string;
  fieldId: number;
}

interface OrderedColumn {
  id: number;
}

type OrderColumnsCallback = (columnsToOrder: Column[], headerName: string) => OrderedColumn[] | null;

const useOrderColumns = (): OrderColumnsCallback => {
    const columnsOrder = useSelector(selectColumnsOrder, areObjectsEqual) as OrderedColumn[];

    return useCallback((columnsToOrder: Column[], headerName: string): OrderedColumn[] | null => {
        const columns = columnsToOrder.filter((c) => !FILTER_COLID_FOR_SORT.includes(c.colId));

        const movedColumn = columns?.find((col) => col?.headerName === headerName);
        if (!movedColumn) {
          return null;
        }
    
        const newIndex = columns.indexOf(movedColumn) - 2;
        if (newIndex < 0) {
          return null;
        }
    
        const oldIndex = columnsOrder?.findIndex(({ id }) => id === Number(movedColumn?.fieldId));
        if (oldIndex === undefined || oldIndex === -1) {
          return null;
        }
        
        if (oldIndex === newIndex) {
          return null;
        }
        
        const orderedColumns = arrayMove(columnsOrder, oldIndex, newIndex);
        return orderedColumns;
    }, [columnsOrder]);
}

export default useOrderColumns;